import React, { useEffect, useMemo } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useSelector } from "react-redux";
import style from "./PortfolioTabNavigation.module.css";
import { CustomButton, CustomDialog, icon } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import { NavUtils } from "../../../../../navigation";
import CustomLink from "../../../../../common/components/links/custom-link/CustomLink";
import Block from "../../../../../common/components/customizable-form/block/Block";
import { useApi } from "../../../../../common/hooks";
import { PortfolioSearchService, UserService } from "../../../../../api";
import { isNonEmptyArray, isNonEmptyObject, multiSort } from "../../../../../common/utils";

export default function AddPortfolioProjectAction() {
	const { call: logWithCompany } = useApi(UserService.loginWithCompany);
	const { call: getAllBUsWithAdminRole } = useApi(PortfolioSearchService.getAllBUsWithAdminRole);
	const myPortfolios = useSelector(({ portfolioSpace }) => portfolioSpace?.myPortfolios);
	const [openModalFilter, setOpenModalFilter] = React.useState(false);
	const [companySelected, setCompanySelected] = React.useState([]);
	const [listAllCompanyContract, setAllListCompanyContract] = React.useState([]);
	const [portfolioSelected, setPortfolioSelected] = React.useState(null);
	const contractCompanies = useMemo(() => {
		if (isNonEmptyArray(listAllCompanyContract)) {
			return listAllCompanyContract?.filter(
				(company) =>
					company.companyName !== "VEOLIA EAU" &&
					company.companyName !== "Contrats" &&
					company.companyName !== "Certificats"
			);
		}
		return [];
	}, [listAllCompanyContract]);
	const certificateCompany = useMemo(
		() => listAllCompanyContract.find((cp) => cp.companyName.toLowerCase() === "certificats"),
		[listAllCompanyContract]
	);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const onGlobalUpdate = ({ valueUuid, value, checked }) => {
		if (checked) {
			setCompanySelected([{ valueUuid, value, checked, id: valueUuid }]);
		} else {
			const oldValue = companySelected;
			const exit = oldValue?.filter((item) => item.value === value);
			if (exit.length > 0) {
				const newValue = oldValue?.filter((item) => item.value !== value);
				setCompanySelected(newValue);
			}
		}
	};
	const handleProjectRedirection = (company, portfolioId) => {
		if (company.id) {
			logWithCompany({ companyId: company.id }).then(() => {
				window.history.pushState({}, "", NavUtils.goNewPortfolio(portfolioId));
				window.location.reload();
			});
		}
	};
	useEffect(() => {
		getAllBUsWithAdminRole()
			.then((data) => {
				setAllListCompanyContract(data);
			})
			.catch(console.error);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<>
			{isNonEmptyArray(listAllCompanyContract) && (
				<div>
					<CustomButton
						aria-controls={open ? "add-portfolio-menu" : undefined}
						aria-expanded={open ? "true" : undefined}
						aria-haspopup="true"
						color="primary"
						endIcon={icon.faChevronDown}
						id="add-portfolio"
						startIcon={icon.faPlus}
						variant="contained"
						onClick={handleClick}
					>
						{translate("common:enum.version-status.new")}
					</CustomButton>
					<Menu
						anchorEl={anchorEl}
						id="add-portfolio-menu"
						MenuListProps={{
							"aria-labelledby": "add-portfolio",
						}}
						open={open}
						TransitionComponent={Fade}
						onClose={handleClose}
					>
						{isNonEmptyArray(myPortfolios) &&
							myPortfolios?.map(
								(item) =>
									(((item.name.toLowerCase() === "contrats" && isNonEmptyArray(contractCompanies)) ||
										(item.name.toLowerCase() === "certificats" &&
											isNonEmptyObject(certificateCompany))) && (
										<MenuItem sx={{ color: "black" }} onClick={handleClose}>
											<CustomButton
												variant="text"
												onClick={() => {
													if (item.name.toLowerCase() === "contrats") {
														// affichage modael bu
														setPortfolioSelected(item.id);
														setOpenModalFilter(true);
													}
													if (item.name.toLowerCase() === "certificats") {
														// switch bu
														handleProjectRedirection(certificateCompany, item.id);
													}
												}}
											>
												{(item?.name?.toLowerCase() === "contrats" &&
													translate("common:licence-management.new.contract")) ||
													translate("common:licence-management.new.certificate")}
											</CustomButton>
											<CustomLink
												className={style.customLink}
												to={NavUtils.goNewPortfolio(item.id)}
											/>
										</MenuItem>
									)) ||
									null
							)}
					</Menu>
					<CustomDialog
						displayCloseCross
						isForm
						open={openModalFilter}
						submitDisabled={!isNonEmptyArray(companySelected)}
						title={translate("common:licence-management.new-contract.dialog.title")}
						onClose={() => {
							setOpenModalFilter(false);
							setCompanySelected([]);
						}}
						onSubmit={() => {
							setOpenModalFilter(false);
							const company = listAllCompanyContract.find((cp) => cp.id === companySelected[0].valueUuid);
							handleProjectRedirection(company, portfolioSelected);
						}}
					>
						<Block
							hiddenLabel
							block={{
								id: "",
								type: "CATEGORY",
								name: translate("common:licence-management.label.territories"),
								options: {
									isMandatory: false,
									items: multiSort(
										contractCompanies?.map((cp) => ({
											...cp,
											name: cp.companyName,
											uuid: cp.id,
										})),
										["name"]
									),
									currentValue: companySelected,
								},
							}}
							deleteSelection={() => {
								setCompanySelected([]);
							}}
							editMode={false}
							onGlobalUpdate={onGlobalUpdate}
						/>
						{isNonEmptyArray(companySelected) && (
							<div className={style.warningCreation}>
								{translate("common:licence-management.new-contract.dialog.warning", {
									companyName: companySelected?.[0]?.value,
								})}
							</div>
						)}
					</CustomDialog>
				</div>
			)}
		</>
	);
}
